import React from 'react';
import Box from 'atomic/utilization/box';
import { RankedProductInterface } from 'interfaces/ranked-product.interface';
import RankingItem from 'components/ranking/ranking-item';
import ProductOffersTitle from 'components/product/product-offer/product-offers-title';
import { dateFormatter } from 'helpers/date-formatter';
import Link from 'atomic/utilization/link';

import './ranking-list.scss';

interface RankingListProps {
    rankedProducts: RankedProductInterface[];
    categoryName: string;
    categoryId: number;
    showButton?: boolean;
}

const RankingList: React.FC<RankingListProps> = ({ rankedProducts, categoryName, showButton, categoryId }) => (
    <div className="ranking-list">
        <div className="ranking-list__title">
            <ProductOffersTitle
                productName={`Ranking ${categoryName}`}
                description={`- ${dateFormatter()}`}
                isLarge={true}
            />
        </div>
        <Box>
            {
                rankedProducts.map(rankedProduct => (
                    <RankingItem key={`ranking-${rankedProduct.product.id}`} rankedProduct={rankedProduct}/>
                ))
            }
            {
                showButton && (
                    <div className="ranking-list__button">
                        <Link size={'lg'} color={'blue'} type={'button'}
                            uppercase={true} outline={true} href={`/cat/${categoryId}/ranking`}
                        >
                            Zobacz cały ranking
                        </Link>
                    </div>
                )
            }
        </Box>
    </div>
);

export default RankingList;
